import { Api } from "../api/api";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { AlertController } from "ionic-angular";

@Injectable()
export class PhoneAuthProvider {
  private url: string = "me/phone";

  constructor(
    public http: HttpClient,
    public api: Api,
    public alertCtrl: AlertController
  ) {}

  putPhoneNum(phone: string): Observable<any> {
    return this.api.put(this.url, { phone: phone });
  }

  putVerifyCode(token: string): Observable<any> {
    return this.api.put(this.url + "_auth", { token: token });
  }

  showDoPhoneAuthAlert(callback: Function) {
    const alert = this.alertCtrl.create({
      title: "電話番号の認証をお願いします",
      subTitle:
        "本人確認に使用することで安全にご利用いただけます。<br />また電話番号が第三者に知られることはありませんのでご安心ください。",
      buttons: [
        {
          text: "OK",
          handler: () => {
            callback();
          },
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/phone-auth/phone-auth.ts